export const mimeTypeExtension = (mime: string): string => {
  // eslint-disable-next-line default-case
  switch (mime) {
    // --- AUDIO ---
    case 'audio/mpeg':
      return 'mp3'
    case 'audio/mp4':
      return 'm4a'
    case 'audio/ogg':
      return 'ogg'
    case 'audio/vorbis':
      return 'oga'
    case 'audio/wav':
    case 'audio/x-wav':
      return 'wav'
    case 'audio/aac':
    case 'audio/x-aac':
      return 'aac'
    case 'audio/flac':
      return 'flac'
    case 'audio/webm':
      return 'weba'
    case 'audio/amr':
      return 'amr'
    case 'audio/*':
      return 'all audio files'

    // --- VIDEO ---
    case 'video/mp4':
      return 'mp4'
    case 'video/webm':
      return 'webm'
    case 'video/ogg':
      return 'ogv'
    case 'video/x-msvideo':
      return 'avi'
    case 'video/x-ms-wmv':
      return 'wmv'
    case 'video/quicktime':
      return 'mov'
    case 'video/mpeg':
      return 'mpeg'
    case 'video/3gpp':
      return '3gp'
    case 'video/3gpp2':
      return '3g2'
    case 'video/*':
      return 'all video files'

    // --- IMAGES ---
    case 'image/jpeg':
      return 'jpg'
    case 'image/png':
      return 'png'
    case 'image/gif':
      return 'gif'
    case 'image/webp':
      return 'webp'
    case 'image/svg+xml':
      return 'svg'
    case 'image/bmp':
      return 'bmp'
    case 'image/tiff':
      return 'tiff'
    case 'image/heic':
    case 'image/heif':
      return 'heic'
    case 'image/*':
      return 'all image files'

    default:
      return ''
  }
}

export const formatBytes = (bytes: number): string => {
  if (bytes === 0) return '40 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  const size = parseFloat((bytes / k ** i).toFixed(2))
  return `${size} ${sizes[i]}`
}
